var React = require('react');

function Heat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.058 3.1L3.85 4.961 5.058 6.84h-.009L3.357 9.475l-1.47-.765 1.207-1.878-1.207-1.87 1.7-2.635 1.47.773zm5.1-.094L8.95 4.886l1.207 1.87-.009.008L8.458 9.39l-1.471-.765 1.207-1.87-1.207-1.87 1.7-2.635 1.47.756zm5.142 0l-1.224 1.879 1.224 1.87v.008L13.6 9.39l-1.487-.765 1.207-1.87-1.207-1.87 1.7-2.635 1.487.756zM0 19.25v-6.8a1.7 1.7 0 0 1 1.7-1.7h13.6a1.7 1.7 0 0 1 1.7 1.7v6.8h-1.7v-1.7H1.7v1.7H0zm3.4-6.8a.85.85 0 0 0-.85.85V15a.85.85 0 0 0 1.7 0v-1.7a.85.85 0 0 0-.85-.85zm3.4 0a.85.85 0 0 0-.85.85V15a.85.85 0 0 0 1.7 0v-1.7a.85.85 0 0 0-.85-.85zm3.4 0a.85.85 0 0 0-.85.85V15a.85.85 0 0 0 1.7 0v-1.7a.85.85 0 0 0-.85-.85zm3.4 0a.85.85 0 0 0-.85.85V15a.85.85 0 0 0 1.7 0v-1.7a.85.85 0 0 0-.85-.85z","fill":"currentColor"}));
}

Heat.defaultProps = {"width":"17","height":"21","viewBox":"0 0 17 21"};

module.exports = Heat;

Heat.default = Heat;
